import { Box } from '@mui/material';
import { Checkbox } from '../../../run-rx/form-controls.jsx';
import { useLpkRunContext } from './lpk-run-context.jsx';

export function NutrientSelectors() {
  const { selectedNutrients, toggleNutrient } = useLpkRunContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 2, sm: 3 },
        mt: 2,
        textTransform: 'uppercase',
      }}
    >
      <NutrientButton
        nutrient="lime"
        selected={selectedNutrients}
        onChange={toggleNutrient}
      />
      <NutrientButton
        nutrient="phosphorus"
        selected={selectedNutrients}
        onChange={toggleNutrient}
      />
      <NutrientButton
        nutrient="potassium"
        selected={selectedNutrients}
        onChange={toggleNutrient}
      />
    </Box>
  );

  function NutrientButton({ nutrient, selected, onChange }) {
    return (
      <Checkbox
        label={nutrient}
        value={nutrient}
        checked={Boolean(selected[nutrient])}
        onChange={() => onChange(nutrient)}
        sx={{ width: 'auto' }}
      />
    );
  }
}
